/**
 * Created by m.igrachev on 6/19/2017.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "true",
        description: "Popover component nests your content, so some children are expected."
    },
    {
        name: "anchor",
        type: "DOM node",
        defaultValue: "n/a",
        isRequired: "true",
        description: "The dom element from which the popover content will pop."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be added to Popover content container."
    },
    {
        name: "active",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true makes the content visible as adding 'tq-active' class."
    },
    {
        name: "popoverType",
        type: "String",
        defaultValue: "",
        isRequired: "false",
        description:
            "Determine when we will have popover content in dom tree.\n" +
            "Тhe default behavior is to render the content only when the popover is active and to remove it when not active.\n" +
            "If 'keep', renders the content when active and keep it in the dom tree when is not active.\n" +
            "If 'load', always render the content in the dom.\n" +
            "Accepts oneOf(['keep', 'load'])"
    },

    {
        name: "offsetLeft",
        type: "Number",
        defaultValue: "0",
        isRequired: "false",
        description: "The provided number is added to calculated 'left' style of the content."
    },
    {
        name: "offsetRight",
        type: "Number",
        defaultValue: "0",
        isRequired: "false",
        description: "The provided number is added to calculated 'right' style of the content."
    },
    {
        name: "offsetTop",
        type: "Number",
        defaultValue: "0",
        isRequired: "false",
        description: "The provided number is added to calculated 'top' style of the content."
    },
    {
        name: "offsetBottom",
        type: "Number",
        defaultValue: "0",
        isRequired: "false",
        description: "The provided number is added to calculated 'bottom' style of the content."
    },

    {
        name: "minWidthToAnchor",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true, force the content minWidth to anchor's width."
    },
    {
        name: "maxWidthToAnchor",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true, force the content maxWidth to anchor's width."
    },
    {
        name: "preferredPosition",
        type: "String",
        defaultValue: "bottom",
        isRequired: "false",
        description:
            "Determine where to show the content\n" +
            "Accepts oneOf(['top', 'top-right', 'top-left', 'bottom', 'bottom-right', 'bottom-left', 'left', 'left-top', 'left-bottom', 'right', 'right-top', 'right-bottom'])"
    },
    {
        name: "onExitViewport",
        type: "Function",
        defaultValue: "",
        isRequired: "false",
        description:
            "A callback function which will be executed, when have active element and scroll it outside of viewport."
    },
    {
        name: "onEnterViewport",
        type: "Function",
        defaultValue: "",
        isRequired: "false",
        description:
            "A callback function which will be executed, when have active element, which come back to viewport."
    },
    {
        name: "closeOnResize",
        type: "Function",
        defaultValue: "false",
        isRequired: "false",
        description:
            "A callback function which will be executed on window resizing. It's component's responsibility to close the popover and lose the focus if needed."
    },
    {
        name: "closeOnScroll",
        type: "Function",
        defaultValue: "false",
        isRequired: "false",
        description:
            "A callback function which will be executed on document scrolling. It's component's responsibility to close the popover and lose the focus if needed."
    }
];

export default documentedProperties;
